import { isPlatform } from '@ionic/react';

enum Platform {
  IOS = 'ios',
  ANDROID = 'android',
  MOBILE_WEB = 'mobileweb',
  ELECTRON = 'electron',
  PWA = 'pwa',
  WEB = 'web',
}

const getPlatform = (): Platform => {
  if (isPlatform('mobileweb')) {
    return Platform.MOBILE_WEB;
  } else if (isPlatform('ios')) {
    return Platform.IOS;
  } else if (isPlatform('android')) {
    return Platform.ANDROID;
  } else if (isPlatform('electron')) {
    return Platform.ELECTRON;
  } else if (isPlatform('pwa')) {
    return Platform.PWA;
  } else {
    return Platform.WEB;
  }
};

export { getPlatform, Platform };
